import React from 'react'

export const foodallergies:string[] = [

"Peanuts",
"Tree Nuts",
"Shellfish",
"Fish",
"Milk",
"Eggs",
"Soy",
"Wheat",
"Gluten",
"Sesame Seeds",
"Mustard",
"Celery",
"Lupin",
"Corn (Maize)",
"Sunflower Seeds",
"Poppy Seeds",
"Beans and Legumes",
"Fruits",
"Vegetables",
"Chocolate",
"Citrus Fruits",
"Coconut",
"Avocado",
"Tomatoes",
"Peas",
"Garlic",
"Onion",
"Ginger",
"Spices",
'Other (Please specify)'
];